import { Dialog } from 'qw-ui-lib-v2';

export default function CloseButtonDialog({
  title,
  onRequestClose,
  open,
  minHeight,
  children,
  actions,
  ...props
}) {
  return (
    <Dialog isOpen={open} onOpenChange={onRequestClose} {...props}>
      <Dialog.Header>{title}</Dialog.Header>
      <Dialog.Body style={{ minHeight }}>{children}</Dialog.Body>
      {actions ? <Dialog.Footer>{actions}</Dialog.Footer> : null}
    </Dialog>
  );
}
